import {createContext, useContext, useMemo} from 'react';
import {
  MessagePartComponentContext,
  MessagePartComponentRegistry,
  MessagePartHandlers,
} from './MessagePartComponentContext';
import {composePartModules} from './MessagePartModule';
import {platformDefaultParts} from './MessageParts/platformDefaultParts';

export const DefaultMessagePartComponentsMap: MessagePartComponentRegistry =
  composePartModules(platformDefaultParts).components;

const EmptyMessagePartComponents: MessagePartComponentRegistry = {};
const EmptyMessagePartHandlers: MessagePartHandlers = {};

const MessagePartHandlersContext = createContext<MessagePartHandlers>({});

export function useMessagePartHandlers(): MessagePartHandlers {
  return useContext(MessagePartHandlersContext);
}

export function MessagePartHandlersProvider({
  value,
  children,
}: {
  value?: MessagePartHandlers;
  children: React.ReactNode;
}) {
  return (
    <MessagePartHandlersContext.Provider
      value={value ?? EmptyMessagePartHandlers}
    >
      {children}
    </MessagePartHandlersContext.Provider>
  );
}

export function MessagePartComponentProvider({
  value,
  children,
}: {
  value?: MessagePartComponentRegistry;
  children: React.ReactNode;
}) {
  const components = useMemo(
    () => ({
      ...DefaultMessagePartComponentsMap,
      ...(value ?? EmptyMessagePartComponents),
    }),
    [value],
  );

  return (
    <MessagePartComponentContext.Provider value={components}>
      {children}
    </MessagePartComponentContext.Provider>
  );
}
